import React from 'react'
import styled from 'styled-components'

import i18n from '../../i18n'
import Icon from '../Icon'
import Close from '../../assets/close.svg'
import breakpoints from '../../constants/breakpoints'

interface Props {
  onClick: () => void
  $inverted?: boolean
  disabled?: boolean
}

const CloseAppButton: React.FC<Props> = ({ onClick, $inverted, disabled }) => (
  <Button onClick={onClick} $inverted={$inverted} disabled={disabled}>
    <Icon icon={Close} />
    <span>{i18n.t('modal.close')}</span>
  </Button>
)

const Button = styled.button<Props>`
  border: none;
  background-color: white;
  color: ${({ $inverted, theme }) => ($inverted ? 'white' : theme.warmGrey)};
  cursor: pointer;
  font-size: 15px;
  padding: 12px 0 12px 15px;
  transition: all 0.3s ease;
  z-index: 1;
  display: flex;

  @media (min-width: ${breakpoints.md}) {
    padding: 12px 15px;
  }

  & div {
    display: inline-block;
  }

  & svg {
    fill: ${({ $inverted, theme }) => ($inverted ? 'white' : theme.warmGrey)};
    width: 10px;
    height: 10px;
    margin-right: 10px;
  }

  &:hover {
    color: ${({ theme }) => theme.darkBlue};

    & svg {
      fill: ${({ theme }) => theme.darkBlue};
    }
  }

  & span {
    display: block;
  }

  @media (min-width: ${breakpoints.md}) {
    top: 20px;
    right: 20px;
    border-radius: 4px;
    border: 1px solid white;
    border-color: ${({ $inverted }) => ($inverted ? 'white' : '#999999')};

    &:hover {
      background-color: ${({ theme }) => theme.darkBlue};
      border-color: ${({ theme }) => theme.darkBlue};
      color: white;

      & svg {
        fill: white;
      }
    }
  }

  ${({ $inverted }) =>
    $inverted &&
    `
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
      border-color: white;
    }
  `};

  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0;
  `};
`

CloseAppButton.defaultProps = {
  disabled: false
}

export default CloseAppButton
